// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/grid-cell","root":"grid-cell-m__root__34wXf","input":"grid-cell-m__input__2g0he","edit":"grid-cell-m__edit__3hH3_"};